module.exports = __webpack_public_path__ + "img/34_1.e1eafb61.png";